<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-row slot="title">
      <a-col :span="24">
        <span>价格规则</span>
        <span class="tips">提示：日价，指景区显示的销售价格；</span>
      </a-col>
    </a-row>
    <div class="content-main">
      <ul>
        <li>本系统价格</li>
        <li>建议销售价</li>
        <li>同行价</li>
        <li>市场价</li>
        <li>采购价</li>
        <li>佣金</li>
      </ul>
      <ul class="right-box">
        <li>环球影城系统价格</li>
        <li>= &nbsp;&nbsp;&nbsp;日价</li>
        <li>= &nbsp;&nbsp;&nbsp;日价 * 95%</li>
        <li>= &nbsp;&nbsp;&nbsp;日价</li>
        <li>= &nbsp;&nbsp;&nbsp;日价 * 95%</li>
        <li>= &nbsp;&nbsp;&nbsp;日价 — 日价*97%</li>
      </ul>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'UbrRules',
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'UbrTicketPro', title: '商品绑定' },
      { name: 'UbrTicketOrder', title: '订单直连' },
      { name: 'UbrAccount', title: '关联账号' }
    ])
  },
  methods: {}
}
</script>
<style scoped lang="less">
.tips {
  font-size: 14px;
  padding-left: 15px;
}

ul, li {
  list-style: none;
  padding: 0;
}

.content-main {
  display: flex;

  ul {
    &:first-child {
      background: #E9E9E9;
    }

    li {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;

      &:first-child {
        font-weight: bold;
      }
    }
  }
}
</style>